import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadChannels} from '../actions/channels.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class ChannelsGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkChannels()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkChannels(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectChannelsLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadChannels());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
